import {ESign, Product} from "../Models/Product/Product";
import {EMeasurementUnitAlias, MeasurementUnit} from "../Models/MeasurementUnit/MeasurementUnit";
import {validateString} from "@musicdata/common/src/Strings/Validation";
import {ENumberValidationOption, validateNumber} from "@musicdata/common/src/Numbers/Validation";
import {validateBoolean} from "@musicdata/common/src/Booleans/Validation";

export class ProductScraper {

    private readonly _entryElement: HTMLElement;

    public constructor(entryElement: HTMLElement) {
        this._entryElement = entryElement;
    }

    public scrape(): Product {

        let product = new Product();
        product.inShopId = this.scrapeInShopId();
        product.inShopCartId = this.scrapeInShopCartId();
        product.measurementUnit = this.scrapeMeasurementUnit();
        product.availableAmount = this.scrapeAvailableAmount();
        product.pieceAmount = this.scrapePieceAmount();
        product.minimumSaleAmount = this.scrapeMinimumSaleAmount();
        product.singList = this.scrapeSignList();

        return product;
    }

    private scrapeInShopId() : number {
        let id = this._entryElement.getAttribute("data-product-id");
        return validateNumber(id);
    }

    public scrapeInShopCartId() : number {
        let id = this._entryElement.getAttribute("data-product-cart-id");
        return validateNumber(id);
    }

    private scrapeMeasurementUnit(): MeasurementUnit {

        let attributeValue = this._entryElement.getAttribute("data-product-measurement-unit-symbol");
        attributeValue = validateString(attributeValue);

        if (attributeValue === null) {
            return new MeasurementUnit(EMeasurementUnitAlias.ks);
        }

        attributeValue = attributeValue.toLowerCase();

        if (!Object.values(EMeasurementUnitAlias).includes(<EMeasurementUnitAlias>attributeValue)) {
            return new MeasurementUnit(EMeasurementUnitAlias.ks);
        }

        return new MeasurementUnit(<EMeasurementUnitAlias>attributeValue);
    }

    private scrapeAvailableAmount(): number {

        let attributeValue = this._entryElement.getAttribute("data-product-amount-in-all-stocks");

        let availableAmount = validateNumber(attributeValue, [
            ENumberValidationOption.forbidInfinity,
            ENumberValidationOption.forbidNegativeNumber,
        ]);

        return availableAmount ?? 0;
    }

    private scrapePieceAmount(): number {

        let attributeValue = this._entryElement.getAttribute("data-product-piece-amount");

        let pieceAmount = validateNumber(attributeValue, [
            ENumberValidationOption.forbidInfinity,
            ENumberValidationOption.forbidNegativeNumber,
        ]);

        return pieceAmount ?? 1;
    }

    private scrapeMinimumSaleAmount(): number {

        let attributeValue = this._entryElement.getAttribute("data-product-minimum-sale-amount");

        let minimumSaleAmount = validateNumber(attributeValue, [
            ENumberValidationOption.forbidInfinity,
            ENumberValidationOption.forbidNegativeNumber,
        ]);

        return minimumSaleAmount ?? 1;
    }

    private scrapeSignList(): Array<ESign> {

        let signValuePairList: Array<[ESign, boolean]> = [];

        signValuePairList.push([ESign.sale, validateBoolean(this._entryElement.getAttribute("data-is-sale"))]);
        signValuePairList.push([ESign.unpacked, validateBoolean(this._entryElement.getAttribute("data-is-unpacked"))]);

        return signValuePairList.filter(([, value]) => {
            return value === true;

        }).map(([sign]) => {
            return sign;
        });
    }
}